export const Switcher = ({checked, onClick, label}) => {
  return (
    <div className={checked ? "switcher checked" : "switcher"} onClick={onClick}>
      <span>{label}</span>
      <div className="fundo">
        <div className="botao"/>
      </div>
    </div>
  );
}